import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, TextareaCustom } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { appointmentActions, httpRequestsOnSuccessActions } from 'store';
import { updateNoteEnums } from './constnats';

const ACTION_TYPE = 'REQUEST_APPT_NOTE';

export const RequestNoteUpdate = ({ afterSuccess, info, apptId, single }) => {
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();
    const { handleSubmit, watch, control, setError, clearErrors, reset } = useForm();

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            afterSuccess();
        }
    }, [success]);

    const handleCreate = (date) => {
        dispatch(
            appointmentActions.requestApptNote(
                apptId,
                { type: updateNoteEnums?.UPDATE_NOTE, noteId: info?.id, message: date?.description },
                single
            )
        );
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Request Note Update</p>
            <p className="modal-header-sub">
                Please provide details for the update request. The author will be notified with your message.
            </p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <TextareaCustom
                        control={control}
                        name="description"
                        label="Update Request Message*"
                        variant={'outlined'}
                        allowCharacter={true}
                        rules={{
                            required: 'Request Message is required.',
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Send Request'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
